import { getCart } from "../utils/getCart";
import { changeCart } from "../utils/changeCart";
import { addCart } from "../utils/addCart";

export default function autoAdd() {
  const autoAddEnable = document.body.dataset.autoAdd;
  const autoAddLimit = document.body.dataset.autoAddLimit;
  const autoAddProduct = document.body.dataset.autoAddProduct
    ? JSON.parse(document.body.dataset.autoAddProduct)
    : null;
  if (!autoAddEnable || !autoAddLimit || !autoAddProduct) return;
  document.addEventListener("updated_cart", async () => {
    const cart = await getCart();
    // check if cart is over limit
    if (cart.total_price >= autoAddLimit) {
      if (!productIsInCart(cart, autoAddProduct)) {
        console.log("cart is over limit, add", autoAddProduct);
        await addCart({
          items: [{ id: autoAddProduct.id.toString(), quantity: "1" }],
        });
        update_cart(function () {
          var event = document.createEvent("Event");
          event.initEvent("updated_cart", true, true);
          document.dispatchEvent(event);
        });
      }
    } else {
      if (productIsInCart(cart, autoAddProduct)) {
        console.log("cart is under limit, remove:", autoAddProduct);
        await changeCart({ id: autoAddProduct.id.toString(), quantity: "0" });
        update_cart(function () {
          var event = document.createEvent("Event");
          event.initEvent("updated_cart", true, true);
          document.dispatchEvent(event);
        });
      }
    }
  });
}

const productIsInCart = (cart: any, product: any) => {
  return cart.items.some((item: any) => item.id === product.id);
};
